<template>
<div v-loading="loading">
  <el-dialog
    v-for="d in dialogList"
    :title="d.title"
    :size="d.size"
    :modal-append-to-body="false"
    :close-on-click-modal="d.isClose == undefined ? true : d.isClose"
    :close-on-press-escape="d.isClose == undefined ? true : d.isClose"
    :show-close="d.isClose == undefined ? true : d.isClose"
    v-model="dialogVisible[d.id]">
    <xform :config="d.form.config" :data="d.form.data" @submitSuccess="formSubmitSuccess(d.id)"></xform>
  </el-dialog>
  <div style="margin-bottom:10px;">
    <el-button
      v-for="btn in topBtns"
      :icon="btn.icon"
      :type="btn.type"
      :disabled="btn.disabled == undefined ? false : btn.disabled"
      @click="clickTopBtn(btn)">
      {{btn.text}}
    </el-button>
  </div>
  <xtable :config="table.config" :data="table.data" @clickRowBtn="clickRowBtn" @getDataBack="getDataBack" @clickMultiBtn="clickMultiBtn" ref="curdTable">
  </xtable>
</div>
</template>

<script>
import ajax from './ajax'
import Xtable from './table'
import Xform from './form'

export default {
  name: 'xcurd',
  props: ['topBtns', 'dialogs', 'table'],
  data() {
    return {
      dialogVisible: {},
      dialogList: [],
      loading: false
    }
  },
  created(){
    this.dialogList = this.dialogs;
    let dv = {}
    for(let i in this.dialogs){
      dv[this.dialogs[i].id] = false;
    }
    this.dialogVisible = dv;
  },
  methods: {
    getDataBack(data){
      this.$emit('getDataBack', data);
    },
    clickRowBtn(btn, row){
      if(btn.dialog == undefined){
        this.$emit('clickRowBtn', btn, row);
      }else{
        for(let i in this.dialogList){
          if(this.dialogList[i].id == btn.dialog){
            // this.dialogList[i].form.data = JSON.parse(JSON.stringify(row));
            let tempData = JSON.parse(JSON.stringify(row));
            // let tempData2 = {};
            // for(let n in this.dialogList[i].form.data){
            //   tempData2[n] = tempData[n];
            // }
            this.dialogList[i].form.data = tempData;
            break;
          }
        }
        this.dialogVisible[btn.dialog] = true;
      }
    },
    clickMultiBtn(btn, data){
      if(btn.dialog == undefined){
        this.$emit('clickMultiBtn', btn, data);
      }else{
        this.dialogVisible[btn.dialog] = true;
      }
    },
    clickTopBtn(btn){
      if(btn.dialog != undefined){
        this.dialogVisible[btn.dialog] = true;
      }else if(btn.ajax !=undefined){
        let _self = this;
        let runAjax = () => {
          _self.loading = true;
          let param = {};
          ajax(_self, 'post', btn.ajax.url, param, (res) => {
            if(response.data.status == 1){
              _self.$message({
                type: 'success',
                showClose: true,
                message: '操作成功!'
              });
            }
          }, () => {
            _self.loading = false;
          })
        }
        if(btn.ajax.confirm != false){
          this.$confirm(btn.ajax.confirm, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            runAjax();
          }).catch(() => {
                     
          });
        }else{
          runAjax();
        }
      }else{
        this.$emit('clickTopBtn',btn);
      }
    },
    formSubmitSuccess(id){
      this.dialogVisible[id] = false;
      this.$refs.curdTable.getData();
    },
    getData(){
      this.$refs.curdTable.getData();
    }
  },
  components: {
    Xtable,
    Xform
  }
}
</script>


// WEBPACK FOOTER //
// curd.vue?1f8b79ac